module.exports = __webpack_public_path__ + "images/stickers/taco-angry.12a291b8be87b3ea21b5.png";